function getQueryString() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const discount = urlParams.get('discount')
	if (discount !== null) {
		sessionStorage.setItem('discount', discount);
	}
}
getQueryString();

if (sessionStorage.getItem('discount') != 'null' && 
    sessionStorage.getItem('discount') != null && 
    sessionStorage.getItem('popupexpired') != 'true' &&
    (localStorage.getItem('impression_id') === null && sessionStorage.getItem('pump_discount_active') === null)
   ) {

	window.addEventListener('load', (event) => {
		let loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
		let params = new URLSearchParams(window.location.search);        
        let sec = (sessionStorage.getItem("sec")!== null) ? sessionStorage.getItem("sec") : params.get("sec");
		sec = sec - Math.floor(loadTime / 1000);
		if (sec < 0)
			sec = 0;


		var request = new XMLHttpRequest(),
			formData = new FormData();
		formData.append('discount', sessionStorage.getItem('discount'));
		new Promise(function (resolve, reject) {
			request.onreadystatechange = function () {
				if (request.readyState !== 4) return;
				if (request.status >= 200 && request.status < 300) {
					let res = JSON.parse(request.response)
					if (res.result !== null) {
						let customerData = res.result;
						let displayForm = document.querySelector('.displayForm');

                      
                      if(customerData !== null){
                          if (typeof customerData.billing_first_name !== 'undefined' && customerData.billing_first_name !== null) {
                              displayForm.querySelector('.name').textContent = customerData.billing_first_name + ', ';
                          }
                          storeCustomerData(customerData)
                      }
                      
					}
					stratTimer(sec);
					document.querySelector(".time-counter-wrapper").removeAttribute("style");
					resolve(request);

				} else {
					console.log('Error: ' + request.statusText)
					reject({
						status: request.status,
						statusText: request.statusText
					});
				}
			};
			request.open('POST', 'https://getpump.app/mojo/api/customer-info', true);
			request.send(formData);

		});


	})

	function stratTimer(sec) {
		let countmDiv = document.querySelector(".minute").querySelectorAll("span")[0],
			countsDiv = document.querySelector(".second").querySelectorAll("span")[0],
			countDown = setInterval(function () {
				'use strict';
				executeTimer();
			}, 1000);

		function executeTimer() {
			let min = Math.floor(sec / 60),
				remSec = sec % 60;
			if (remSec < 10)
				remSec = '0' + remSec;
			if (min < 10)
				min = '0' + min;
			countmDiv.innerHTML = min;
			countsDiv.innerHTML = remSec;
			if (sec > 0) {
				sec = sec - 1;
				sessionStorage.setItem("sec", sec);
			} else {
				clearInterval(countDown);

				document.querySelector(".time-counter-container").querySelector('h3').textContent = 'Expired';
				document.querySelector(".offr-text").style.display = "none";
				sessionStorage.setItem('popupexpired', true);

				setTimeout(() => {
					document.querySelector(".time-counter-wrapper").style.display = "none";

				}, 20000);

			}
		}
	}
}

function storeCustomerData(customerData){
  let custData = {
    'billing_email': customerData.billing_email,
    'shipping_first_name': customerData.shipping_first_name,
    'shipping_last_name': customerData.shipping_last_name,
    'shipping_address1': customerData.shipping_address1,
    'shipping_address2': customerData.shipping_address2,
    'shipping_city': customerData.shipping_city,
    'shipping_zip': customerData.shipping_zip,
    'shipping_phone': customerData.shipping_phone      
  }
  sessionStorage.setItem('customer_data', JSON.stringify(custData))
}